module.exports = "/_next/static/images/Pictogram_phone-2dfbafa4684b7dae1a7f5b0466dd993e.svg";